/* accordion
========================================================*/
export function initAccordionFunctions() {

    let accordion = $(".js-accordion");
    let accordionTrigger = accordion.find(".modAccordion__item__question");

    accordionTrigger.on("click", function(){
        $(this).toggleClass("is-active");
        $(this).next().slideToggle();
    });

}
